
  import { defineComponent, PropType } from 'vue';

  import ComponentInput from '@/common/components/ComponentInput.vue';

  import type { TProcessedTreeOption } from './types';

  export default defineComponent({
    name: 'TreeMultiselectOption',
    components: {
      ComponentInput,
    },
    props: {
      item: {
        type: Object as () => TProcessedTreeOption,
        required: true,
      },
      isClickAnyNode: {
        type: Boolean,
        default: false,
      },
      selectedValueSet: {
        type: Object as PropType<Set<string | number>>,
        required: true,
      },
      expandedItems: {
        type: Object as () => Set<string>,
        required: true,
      },
    },
    emits: ['toggleSelection', 'toggleExpanded', 'openContextMenu'],
    computed: {
      isSelected() {
        return this.selectedValueSet.has(this.item.value);
      },
      isExpanded() {
        return this.expandedItems.has(this.getItemKey(this.item));
      },
      contentPaddingLeft() {
        return `${(this.item.level - 1) * 12 + 8}px`;
      },
    },
    methods: {
      getItemKey(item: TProcessedTreeOption) {
        return `${item.value}-${item.level}`;
      },
      openContextMenu(item: TProcessedTreeOption, event: MouseEvent) {
        if (!this.isClickAnyNode && !this.item.hasChildren) return;

        this.$emit('openContextMenu', item, event);
      },
    },
  });
